const baseUrl = process.env.REACT_APP_BASE_URL;

// eslint-disable-next-line import/prefer-default-export
export { baseUrl };
